import Vue from 'vue'

export const LOADING_START = (state) => {
  state.loading = true
}

export const LOADING_DONE = (state) => {
  state.loading = false
}

export const SET_DATA = (state, data) => {
  Vue.set(state, 'data', data)
}

export const SET_SCHEMA = (state, schema) => {
  Vue.set(state, 'schema', schema)
}



// WEBPACK FOOTER //
// ./src/store/modules/creator/mutations.js